export default "__VITE_ASSET__BsJRqlRB__"